export default __webpack_public_path__ + "static/media/EBS_2011-2012.bbd2328a.pdf";